import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { ThemeProp } from '../../../theme/Themes';
import { setSVGChildColors } from '../../../utils/Listings';

export const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;

  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    flex: 1;
  }
`;

export const TitleContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const NavigationContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1.5rem;
  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    display: none;
  }
`;

interface NavigationItemProps {
  $addMobileBorderBottom?: boolean;
  $disableActiveState?: boolean;
}

export const NavigationItem = styled(NavLink)<NavigationItemProps>`
  display: flex;
  gap: 0.625rem;
  align-items: center;
  cursor: pointer;
  font-weight: ${(props) => props.theme.fontWeight.semibold};
  font-size: ${(props) => props.theme.fontSize.s};
  line-height: ${(props) => props.theme.lineHeight.m};
  padding: 1.125rem 1rem;
  color: ${(props) => props.theme.colors.content.default};
  ${(props: ThemeProp) => setSVGChildColors(props.theme.colors.content.default)}
  border-radius: 0.375rem;

  ${(props: NavigationItemProps) =>
    !props.$disableActiveState &&
    css`
      &.active {
        background: ${(props: ThemeProp) => props.theme.colors.main.c050};
        color: ${(props) => props.theme.colors.main.c600};
        ${(props: ThemeProp) => setSVGChildColors(props.theme.colors.main.c600)}
      }
    `};

  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    padding: 1.25rem 0;
    ${(props: ThemeProp & NavigationItemProps) =>
      props.$addMobileBorderBottom && `border-bottom: 1px solid ${props.theme.colors.layout.divider};`}
    font-size: ${(props) => props.theme.fontSize.ml};
    line-height: ${(props) => props.theme.lineHeight.xs};
    gap: 0.5rem;
  }
`;

export const NavigationContainerMobile = styled.div`
  flex-direction: row;
  justify-content: space-between;
  display: none;
  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    display: flex;
  }
  border-bottom: 1px solid ${(props) => props.theme.colors.greyscale.c300};
  margin-bottom: 1.5rem;
`;

export const NavigationItemMobileWrapper = styled.div`
  display: flex;
  height: 2.75rem;
  width: 50%;
`;

export const NavigationItemMobile = styled(NavLink)`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: start;
  cursor: pointer;
  font-weight: ${(props) => props.theme.fontWeight.regular};
  font-size: ${(props) => props.theme.fontSize.s};
  padding: 0 1rem;
  color: ${(props) => props.theme.colors.black};

  &.active {
    font-weight: ${(props) => props.theme.fontWeight.semibold};
    border-bottom: 2px solid ${(props) => props.theme.colors.primary.c500};
  }
`;

const LRContainer = styled.div`
  background: ${(props: ThemeProp) => props.theme.colors.secondary['12-light-blue']};
  box-shadow: 0px 2px 4px rgba(0, 25, 85, 0.04);
  border-radius: 4px;
`;

export const RightContainer = styled(LRContainer)`
  @media (min-width: ${(props) => props.theme.breakpoints.desktop}) {
    min-width: 43rem !important;
    padding: 3rem 3rem !important;
  }
  @media (min-width: ${(props) => props.theme.breakpoints.tablet}) {
    padding: 2rem 2.375rem;
    min-width: 24.375rem;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    margin-top: 0;
    padding: 1rem 1rem 1.5rem 1rem;
  }
`;

export const Form = styled.form`
  display: flex;
  gap: 1.5rem;
  flex: 0 1 30rem;
  flex-direction: row;

  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    flex-direction: column;
    flex: 1;
  }
`;
